import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/site/SmoothScroll";
import ProtectedRoute from "@/components/site/ProtectedRoute";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Government from "@/pages/Government";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import CandidatePortal from "@/pages/CandidatePortal";
import ClientPortal from "@/pages/ClientPortal";
import LightPreview from "@/pages/LightPreview";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ResetPassword from "@/pages/ResetPassword";

function Chrome() {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/preview") || pathname.startsWith("/admin") || pathname === "/candidate-portal" || pathname === "/client-portal" || pathname === "/reset-password";
  return (
    <>
      {!bare && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/government" element={<Government />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/client-portal" element={<ClientPortal />} />
          <Route path="/candidate-portal" element={<CandidatePortal />} />
          <Route path="/preview-light" element={<LightPreview />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </main>
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App grain relative min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <Chrome />
          </SmoothScroll>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
